import { useState, useEffect } from "react";
import Header from "../../../componente/header";
import "./style.css";
import api from "../../../services/api";
import Modal from "react-modal";
import PopUp from "../../../componente/popup";
import PopUpMotivoExclusao from "../../../componente/popup";
import { podeInserir, podeEditar, podeExcluir } from "../../../componente/permissoes";

function CadProduto() {
  const [listagrupo, setlistagrupo] = useState([]);
  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodproduto, setedtcodproduto] = useState(0);
  const [edtdescricao, setedtdescricao] = useState("");
  const [edtpreco, setedtpreco] = useState(0);
  const [edtcodgrupo, setedtcodgrupo] = useState(0);
  const [edtativo, setedtativo] = useState("");

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const handleOpen = (cad) => {
    setedtcodproduto(cad.codproduto);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      Excluir();
      setIsOpenMotivoExclusao(false);
      ListarProduto();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    function ListarGrupo() {
      api
        .get("v1/cadastro/grupoproduto", {
          params: {
            busca: abusca,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistagrupo(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarGrupo();
  }, [abusca
    , showform]);


  function ListarProduto() {
    api
      .get("v1/cadastro/produto", {
        params: {
          busca: abusca,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarProduto();
  }, [abusca, showform, handleConfirma]);

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/produto",
        {
          descricao: edtdescricao,
          preco: edtpreco,
          ativo: edtativo,
          codusuario: localStorage.getItem("tempCodUsuario"),
          excluido: "N",
          codempresa: 1,
          codgrupo: edtcodgrupo,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        ListarProduto();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/produto",
        {
          codproduto: edtcodproduto,
          codgrupo: edtcodgrupo,
          descricao: edtdescricao,
          preco: edtpreco,
          codusuario: localStorage.getItem("tempCodUsuario"),
          ativo: edtativo,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        ListarProduto();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/produto", {
        params: {
          codproduto: edtcodproduto,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        ListarProduto();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodproduto(0);
    setedtcodgrupo(0);
    setedtdescricao("");
    setedtpreco(0);
    setedtativo("S");
  }

  function openModalEditar(props) {
    setshowform(true);
    setnovo(false);

    setedtcodproduto(props.codproduto);
    setedtcodgrupo(props.codgrupo);
    setedtdescricao(props.descricao);
    setedtpreco(props.preco);
    setedtativo(props.ativo);
  }

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div>
          <div>
            <PopUp isOpen={isOpen} onClose={handleClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUp>
          </div>

          <div>
            <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
              <h2>Antes de Excluir</h2>
              <p>Informe qual o motivo da exclusão?</p>

              <div className="col-sm-12">
                <label htmlFor="motivo" className="form-label">
                  Motivo
                </label>
                <input
                  type="text"
                  id="motivo"
                  className="form-control"
                  placeholder="Descreva aqui"
                  value={edtMotivo}
                  onChange={(e) => setEdtMotivo(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleInformarMotivoExclusao}
                  >
                    Informar
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                    Cancelar
                  </button>
                </div>
              </div>
            </PopUpMotivoExclusao>
          </div>

          <Modal
            isOpen={showform}
            onRequestClose={closeModal}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
              </div>              

              <div className="modal-body">
                <form>
                  <div className="row col-sm-12">
                    <div className="col-sm-9">
                      <label htmlFor="descricao" className="form-label">
                        Descrição
                      </label>
                      <input
                        type="text"
                        id="descricao"
                        className="form-control"
                        placeholder="Descrição"
                        value={edtdescricao}
                        onChange={(e) => setedtdescricao(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="preco" className="form-label">
                        Preço
                      </label>
                      <input
                        type="number"
                        id="preco"
                        className="form-control"
                        placeholder="Preço"
                        value={edtpreco}
                        onChange={(e) => setedtpreco(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-8">
                      <label htmlFor="grupoproduto" className="form-label">
                        Grupo do Produto
                      </label>
                      <select
                        className="form-select"
                        value={edtcodgrupo}
                        onChange={(e) => setedtcodgrupo(e.target.value)}
                      >
                        <option value="0">Escolha o grupo</option>
                        {listagrupo.map(function (grupo) {
                          return (
                            <option key={grupo.codgrupo} value={grupo.codgrupo}>
                              {grupo.descricao}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="col-sm-4">
                      <div>
                        <label htmlFor="ativo1" className="form-label">
                          Ativo
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="S"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "S"}
                          />
                          <label
                            className="form-check-label"
                            for="inlineRadio1"
                          >
                            Sim
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="N"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "N"}
                          />
                          <label className="form-check-label">Não</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button className="btn btn-danger ms-4" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button className="btn btn-success ms-4" onClick={Salvar}>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        <div className="row">
          <h1 className="ms-4">Cadastro de Produto</h1>
          <p className="ms-4">
            Rotina para cadastrar todos os produtos da empresa.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-10">
            <label className="d-block" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código ou descrição"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => setabusca(e.target.value)}
            />
          </div>
          <div className="col-2 d-flex justify-content-center">
            <button
              className="btn btn-success btnnovo"
              onClick={() => openModalNovo()}
              disabled={!podeInserir("/cadastro/produto")}
            >
              Novo
            </button>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="codigo">Código</th>
                <th className="razao">Descrição</th>
                <th className="cnpj">Preço</th>
                <th className="fantasia">Grupo</th>
                <th className="acao">Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(function (item) {
                return (
                  <tr key={item.codproduto}>
                    <th>{item.codproduto}</th>
                    <th>{item.descricao}</th>
                    <th>{item.preco}</th>
                    <th>{item.grupo}</th>
                    <th>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn fa-regular fa-pen-to-square"
                          onClick={() => openModalEditar(item)}
                          disabled={!podeEditar("/cadastro/produto")}
                        ></button>
                        <button
                          className="btn fa-solid fa-trash"
                          onClick={() => handleOpen(item)}
                          disabled={!podeExcluir("/cadastro/produto")}
                        ></button>
                      </div>
                    </th>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}

export default CadProduto;
